import React from 'react'

const PanelTitle: React.FC = (props) => (
	<h3 className="text-lg font-bold leading-6 mb-4">{props.children}</h3>
);

export default PanelTitle
